import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Header() {

  const [top, setTop] = useState(true);

  // detect whether user has scrolled the page down by 10px 
  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true)
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]);  

  function toggleMenu() {
    const navToggle = document.getElementsByClassName("toggle");
    for (let i = 0; i < navToggle.length; i++) {
      navToggle.item(i).classList.toggle("hidden");
    }
  };
  

  return (
    <header className={`fixed w-full z-30  md:bg-opacity-90 transition duration-300 ease-in-out ${!top && 'bg-blue-1000 blur shadow-xl'}`}>
        <div className="items-center justify-between px-8 py-2 md:flex md:px-12">
            <div className="flex items-center justify-between">
               <div className="text-2xl font-bold text-green-400 md:ml-6 lg:ml-12 md:text-4xl lg:4xl">
                    <Link to="#">HackPitch<span className="text-2xl font-bold text-yellow-400 md:text-4xl lg:5xl">.</span></Link>
               </div>

                <div className="md:ml-6 md:hidden">
                    <button id="hamburger" onClick={toggleMenu} type="button" className="block text-green-400 hover:text-green-400 focus:text-green-700 focus:outline-none">
                        <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                            <path className="hidden" d="M16.24 14.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 0 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12l2.83 2.83z"/>
                            <path d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/>
                        </svg>
                    </button>
                </div>

            </div>

            <div className="flex flex-col sm:hidden toggle lg:mr-12 md:flex-row md:block">
                <Link onClick={toggleMenu} to="/experts" target="_blank" className="px-4 py-3 font-medium text-black bg-green-400 border-2 border-black rounded-md hover:border-white md:mx-2 md:my-2">Experts</Link>
                <a onClick={toggleMenu} href="https://discord.gg/zcvDYPF9" target="_blank" rel="noopener noreferrer" className="px-3 py-3 font-medium text-black bg-green-400 border-2 border-black rounded-md hover:border-white md:mx-2 md:my-2">Community</a>
                <a onClick={toggleMenu} href="https://hackpitch.rapidr.io/contribute/" className="px-3 py-3 font-medium text-black bg-yellow-300 border-2 border-black rounded-md md:mx-2 md:my-2 hover:border-white hover:bg-green-400 hover:text-black">Request a Feature</a>
            </div>

        </div>
    </header>
  );
}

export default Header;
